import * as BulkUpdateHistoryActions from './bulk-update.actions';
import * as BulkUpdateLogActions from './bulk-update-log.actions';

export {
    BulkUpdateHistoryActions, BulkUpdateLogActions
};
